import { SingleToolsBootstrap } from '@quicktools/shared-components';
import initI18n from '@quicktools/shared-components/services/i18n';
import Head from 'next/head';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import React from 'react';
import NextThirdParty from '@quicktools/shared-components/components/common/NextThirdParty';

import {
  TRACKING_ID,
  TRACKING_ID_4,
  HOTJAR_ID,
  BUGSNAG_ID,
  VERSION,
  RECAPTCHA_SITE_KEY,
} from '../configs';
import translations from '../services/i18n/translation.json';
import analytics from '../services/analytics';

import type { AppProps } from 'next/app';

Bugsnag.start({
  apiKey: BUGSNAG_ID,
  plugins: [new BugsnagPluginReact()],
  appVersion: VERSION,
});

const ErrorBoundary = Bugsnag.getPlugin('react').createErrorBoundary(React);

analytics.init();
initI18n(translations);

console.log('Using version tag:', VERSION);

function MyApp({ Component, pageProps }: AppProps) {
  return (
    <ErrorBoundary>
      <Head>
        <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1" />
      </Head>

      <SingleToolsBootstrap>
        <Component {...pageProps} />
      </SingleToolsBootstrap>

      <NextThirdParty
        gAnalytics4Id={TRACKING_ID_4}
        gAnalyticsId={TRACKING_ID}
        hotjarId={HOTJAR_ID}
        recaptchaSiteKey={RECAPTCHA_SITE_KEY}
      />
    </ErrorBoundary>
  );
}

export default MyApp;
